import React from 'react';
import './Settings.css';

interface SettingsProps {
  isOpen: boolean;
  onClose: () => void;
  currentTheme: string;
  onThemeChange: (theme: string) => void;
}

const Settings: React.FC<SettingsProps> = ({ isOpen, onClose, currentTheme, onThemeChange }) => {
  if (!isOpen) return null;

  const themes = [
    {
      id: 'modern',
      name: '现代风格',
      description: '渐变色彩，圆角设计，适合年轻用户',
      preview: '🎨'
    },
    {
      id: 'minimal',
      name: '简约风格',
      description: '清新淡雅，简洁明了，适合商务用户',
      preview: '✨'
    },
    {
      id: 'dark',
      name: '深色风格',
      description: '护眼深色，现代科技感，适合夜间使用',
      preview: '🌙'
    }
  ];

  const handleThemeSelect = (themeId: string) => {
    onThemeChange(themeId);
  };

  const handleOverlayClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="settings-overlay" onClick={handleOverlayClick}>
      <div className="settings-modal">
        <div className="settings-header">
          <h2 className="settings-title">设置</h2>
          <button className="close-button" onClick={onClose}>
            ×
          </button>
        </div>
        
        <div className="theme-section">
          <h3 className="theme-title">选择主题风格</h3>
          <div className="theme-options">
            {themes.map((theme) => (
              <div
                key={theme.id}
                className={`theme-option ${currentTheme === theme.id ? 'selected' : ''}`}
                onClick={() => handleThemeSelect(theme.id)}
              >
                <div className={`theme-preview ${theme.id}`}>
                  {theme.preview}
                </div>
                <div className="theme-info">
                  <div className="theme-name">{theme.name}</div>
                  <div className="theme-description">{theme.description}</div>
                </div>
                <div className="theme-check">
                  {currentTheme === theme.id ? '✓' : ''}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Settings; 